{
  "staff-selection-dialog": {
    "buttons": {
      "close": "Đóng",
      "select": "Chọn",
      "selected": "Đã chọn"
    },
    "text": {
      "title": "Lựa chọn nhân viên",
      "first-available": "Nhân viên bất kỳ"
    }
  }
}
